/* global google */
import IdentityProvider from './IdentityProvider';
import {IIdentityProviderCredentials} from '../IIdentityProvider';
import Cookies from 'js-cookie';

interface IGoogleAuthResponse {
	credential?: string;
	access_token?: string;
}

/**
 * Represents GoogleIdentityProvider
 */
class GoogleIdentityProvider extends IdentityProvider {

	/**
	 * Open One Tap popup
	  * @returns {Promise} promise resolved when the sign in process ends or popup not displayed
	 */
	private oneTap(): Promise<IGoogleAuthResponse | null> {
		return new Promise((resolve) => {
			Cookies.remove('g_state');
			(google as any).accounts.id.initialize({
				client_id: this.config.clientId,
				cancel_on_tap_outside: false,
				callback: (response) => {
					resolve(response);
				}
			});

			(google as any).accounts.id.prompt((notification) => {
				if ((
					notification.isNotDisplayed()
					&& notification.getNotDisplayedReason() === 'opt_out_or_no_session'
				) || notification.isSkippedMoment()
				) {
					resolve(null);
				}
			});
		});
	}

	/**
	 * Authenticate the user if there is no google access
	 * in the browser session
	 * @returns {Promise} promise resolved when the auth process ends
	 */
	protected auth() {
		return new Promise((resolve) => {
			(google as any).accounts.oauth2.initTokenClient({
				client_id: this.config.clientId,
				scope: 'openid profile email',
				callback: (res) => {
					resolve(res);
				},
			}).requestAccessToken();
		});
	}

	/**
	 * Return the provider credentials
	 * @returns {Promise<IIdentityProviderCredentials>|null} object containing credentials
	 */
	async getProviderCredentials(): Promise<IIdentityProviderCredentials> {
		try {
			let response = await this.oneTap();

			if (!response) {
				(google as any).accounts.id.cancel();
				response = await this.auth() as IGoogleAuthResponse;
			}

			return {
				'providerId': 'google',
				'providerData': {
					'idToken': response.credential,
					'accessToken': response.access_token,
				},
			};
		} catch (e) {
			return null;
		}
	}
}

export default new GoogleIdentityProvider();
